export const mainDomains: Dictionary<boolean> = {
  'banzai.bet': true,
};
